import { createReducer, on } from '@ngrx/store';

import { AccountNavigationBlock } from 'ish-core/models/account-navigation-block/account-navigation-block.model';

import { accountNavigationBlocksActions } from './account-navigation-blocks.actions';

export interface AccountNavigationBlocksState {
  blocks: AccountNavigationBlock[];
}

const initialState: AccountNavigationBlocksState = {
  blocks: [],
};

export const accountNavigationBlocksReducer = createReducer(
  initialState,

  // the cards of the user profile are the truth, they are taken over whenever the profile changes
  on(
    accountNavigationBlocksActions.syncAccountNavigationBlocks,
    (state, action): AccountNavigationBlocksState => ({
      ...state,
      blocks: action.payload.blocks,
    })
  ),

  // the card is added, changed and removed right away so the navigation reacts immediately, the profile
  // is saved afterwards and syncs the state back once the server confirmed or rejected it
  on(
    accountNavigationBlocksActions.addAccountNavigationBlock,
    (state, action): AccountNavigationBlocksState => ({
      ...state,
      blocks: [...state.blocks, action.payload.block],
    })
  ),

  on(
    accountNavigationBlocksActions.updateAccountNavigationBlock,
    (state, action): AccountNavigationBlocksState => ({
      ...state,
      blocks: state.blocks.map(block => (block.id === action.payload.block.id ? action.payload.block : block)),
    })
  ),

  on(
    accountNavigationBlocksActions.removeAccountNavigationBlock,
    (state, action): AccountNavigationBlocksState => ({
      ...state,
      blocks: state.blocks.filter(block => block.id !== action.payload.id),
    })
  )
);
